module.exports = __webpack_public_path__ + "img/print.4f81d916.jpg";